import type { InventoryFormValues, InventoryLookups } from '../../types/inventoryForm.types';

interface CommercialInfoSectionProps {
    values: InventoryFormValues;
    lookups?: InventoryLookups;
    onChange: <K extends keyof InventoryFormValues>(key: K, value: InventoryFormValues[K]) => void;
}

function FieldLabel({ text, required = false }: { text: string; required?: boolean }) {
    return (
        <label className="mb-2 block sm:text-sm text-xs text-slate-700">
            {text}
            {required ? <span className="text-red-500"> *</span> : null}
        </label>
    );
}

export function CommercialInfoSection({ values, lookups, onChange }: CommercialInfoSectionProps) {
    return (
        <div className="rounded-md border border-slate-200 bg-white p-3 space-y-4">
            <h3 className="sm:text-sm text-xs text-slate-900 border-b border-slate-100 pb-2">Thông tin thương mại</h3>
            <div className="grid grid-cols-1 gap-4 lg:grid-cols-3">
                <div className="space-y-1">
                    <FieldLabel text="Nhà cung cấp" />
                    <select
                        value={values.supplier_name}
                        onChange={(event) => onChange('supplier_name', event.target.value)}
                        className="h-10 w-full rounded-md border border-slate-200 bg-white px-3 sm:text-sm text-xs focus:border-emerald-500 focus:outline-none"
                    >
                        <option value="">Chọn nhà cung cấp</option>
                        {(lookups?.supplierOptions ?? []).map((option, index) => (
                            <option key={`${option.value}-${index}`} value={option.value}>{option.label}</option>
                        ))}
                    </select>
                </div>
                <div className="space-y-1">
                    <FieldLabel text="Xuất xứ / Hãng SX" />
                    <input
                        value={values.origin_name}
                        onChange={(event) => onChange('origin_name', event.target.value)}
                        className="h-10 w-full rounded-md border border-slate-200 bg-white px-3 sm:text-sm text-xs focus:border-emerald-500 focus:outline-none"
                        placeholder="Nhập xuất xứ hoặc hãng"
                    />
                </div>
                <div className="space-y-1">
                    <FieldLabel text="Mã nhà sản xuất" />
                    <input
                        value={values.manufacturer_code}
                        onChange={(event) => onChange('manufacturer_code', event.target.value)}
                        className="h-10 w-full rounded-md border border-slate-200 bg-white px-3 sm:text-sm text-xs focus:border-emerald-500 focus:outline-none"
                        placeholder="Mã nhà sản xuất nếu có"
                    />
                </div>
            </div>
        </div>
    );
}
